// Unlogged component
const LazyLoadUnloggedComponent = () => import(/* webpackChunkName: "unlogged" */ "./views/unlogged.vue");
const LazyLoadLoginComponent = () => import(/* webpackChunkName: "login" */ "./views/unlogged/login.vue");
const LazyLoadPasswordLostComponent = () => import(/* webpackChunkName: "password-lost" */ "./views/unlogged/passwordLost.vue");
const LazyLoadPasswordRecoverComponent = () => import(/* webpackChunkName: "password-recover" */ "./views/unlogged/passwordRecover.vue");
const LazyLoadRegisterComponent = () => import(/* webpackChunkName: "register" */ "./views/unlogged/register.vue");
const LazyLoadValidateComponent = () => import(/* webpackChunkName: "validate" */ "./views/unlogged/validate.vue");

const LazyLoadLoggedComponent = () => import(/* webpackChunkName: "logged" */ "./views/logged.vue");
const LazyLoadNoteEditorComponent = () => import(/* webpackChunkName: "note" */ "./views/logged/note.vue");

export default [
    {
        path: "/________________DO_NOT_USE_1",
        component: LazyLoadUnloggedComponent,
        meta: {
            requiresAuth: false
        },
        children: [
            {
                path: "/login",
                name: "login",
                component: LazyLoadLoginComponent,
                meta: {
                    title: "login",
                    requiresAuth: false
                }
            },
            {
                path: "/password-lost",
                name: "password-lost",
                component: LazyLoadPasswordLostComponent,
                meta: {
                    title: "password-lost",
                    requiresAuth: false
                }
            },
            {
                path: "/password-recover/:password_lost_link",
                name: "password-recover",
                component: LazyLoadPasswordRecoverComponent,
                meta: {
                    title: "password-recover",
                    requiresAuth: false
                }
            },
            {
                path: "/register",
                name: "register",
                component: LazyLoadRegisterComponent,
                meta: {
                    title: "register",
                    requiresAuth: false
                }
            },
            {
                path: "/validate/:validation_link",
                name: "validate",
                component: LazyLoadValidateComponent,
                meta: {
                    title: "validate",
                    requiresAuth: false
                }
            }
        ]
    },



    {
        path: "/",
        component: LazyLoadLoggedComponent,
        meta: {
            title: "dashboard",
            requiresAuth: true
        },
        children: [
            {
                path: "/",
                name: "home",
                component: LazyLoadNoteEditorComponent,
                meta: {
                    title: "new-note",
                    requiresAuth: true
                },
            },
            {
                path: "/note/:note_id",
                name: "home.filled-note-editor",
                component: LazyLoadNoteEditorComponent,
                meta: {
                    title: "edit-note",
                    requiresAuth: true
                },
            },
        ]
    }
];